"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-lorenzo-di-sebato": {
    "ad0bd022": [{
      "hkey": "613ab21e",
      "slug": "campolino",
      "name": "Campolino",
      "primary": true,
      "skipSearch": false
    }],
    "capolino": [{
      "hkey": "613ab21e",
      "slug": "campolino",
      "name": "Campolino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "53abeb65": [{
      "hkey": "30be4676",
      "slug": "costa-d-onies",
      "name": "Costa d'Onies",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "30be4676",
      "slug": "costa-d-onies",
      "name": "Costa d'Onies",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ea499627": [{
      "hkey": "b9b3a58e",
      "slug": "san-lorenzo-di-sebato",
      "name": "San Lorenzo di Sebato",
      "primary": true,
      "skipSearch": false
    }],
    "maria-di-sares": [{
      "hkey": "b9b3a58e",
      "slug": "san-lorenzo-di-sebato",
      "name": "San Lorenzo di Sebato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "07c8752f": [{
      "hkey": "b9b3a58e",
      "slug": "san-lorenzo-di-sebato",
      "name": "San Lorenzo di Sebato",
      "primary": true,
      "skipSearch": false
    }],
    "ronchi": [{
      "hkey": "b9b3a58e",
      "slug": "san-lorenzo-di-sebato",
      "name": "San Lorenzo di Sebato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;